import { ReactComponent as ArrowUpIcon } from '@app/assets/arrow-up.svg';
import Swiper from '@app/domains/common/components/Swiper';
import { HomeEvents } from '@app/domains/home/analytics/posthog/events';
import { HOME_SWIPER_NAV_BTN_STYLE } from '@app/domains/home/styles';
import clsx from 'clsx';
import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type HomeSwiperControllerProps = PropsWithChildren<{
    className?: string;
}>;

function HomeSwiperController({ className, children }: HomeSwiperControllerProps) {
    return <div className={twMerge(clsx('flex justify-center py-12', className))}>{children}</div>;
}

const PrevButton = () => (
    <Swiper.Prev
        className={HOME_SWIPER_NAV_BTN_STYLE}
        data-posthog-click-event={HomeEvents.ClickPreviousCollectionArrow}
    >
        <ArrowUpIcon className="h-16 w-16 -rotate-90" />
    </Swiper.Prev>
);

const Pages = () => <Swiper.Pages className="flex !w-auto items-center px-16"></Swiper.Pages>;

const NextButton = () => (
    <Swiper.Next className={HOME_SWIPER_NAV_BTN_STYLE} data-posthog-click-event={HomeEvents.ClickNextCollectionArrow}>
        <ArrowUpIcon className="h-16 w-16 rotate-90" />
    </Swiper.Next>
);

HomeSwiperController.PrevButton = PrevButton;
HomeSwiperController.Pages = Pages;
HomeSwiperController.NextButton = NextButton;

export default HomeSwiperController;
